import React, { useState, useRef } from "react";
import IconButton from "@material-ui/core/IconButton";
import { Grid, Slider } from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import ChatiaPopover from "../ChatiaPopover";

const VolumeIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="24"
    height="24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M18 14.8135V9.18646C18 6.04126 18 4.46866 17.074 4.0773C16.1481 3.68593 15.0583 4.79793 12.8787 7.02192C11.7499 8.17365 11.1059 8.42869 9.5 8.42869C8.3879 8.42869 7.02749 8.28131 6.33706 9.33566C6 9.85038 6 10.5669 6 12C6 13.4331 6 14.1496 6.33706 14.6643C7.02749 15.7187 8.3879 15.5713 9.5 15.5713C11.106 15.5713 11.7499 15.8264 12.8787 16.9781C15.0583 19.2021 16.1481 20.3141 17.074 19.9227C18 19.5313 18 17.9587 18 14.8135Z" />
  </svg>
);

const VolumeUpIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="20"
    height="20"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M14 14.8135V9.18646C14 6.04126 14 4.46866 13.0747 4.0773C12.1494 3.68593 11.0603 4.79793 8.88232 7.02192C7.75439 8.17365 7.11085 8.42869 5.50604 8.42869C4.10257 8.42869 3.40084 8.42869 2.89675 8.77262C1.85035 9.48655 2.00852 10.882 2.00852 12C2.00852 13.118 1.85035 14.5134 2.89675 15.2274C3.40084 15.5713 4.10257 15.5713 5.50604 15.5713C7.11085 15.5713 7.75439 15.8264 8.88232 16.9781C11.0603 19.2021 12.1494 20.3141 13.0747 19.9227C14 19.5313 14 17.9587 14 14.8135Z" />
    <path d="M17 12H22M19.5 14.5L19.5 9.5" />
  </svg>
);

const VolumeDownIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="20"
    height="20"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M14 14.8135V9.18646C14 6.04126 14 4.46866 13.0747 4.0773C12.1494 3.68593 11.0603 4.79793 8.88232 7.02192C7.75439 8.17365 7.11085 8.42869 5.50604 8.42869C4.10257 8.42869 3.40084 8.42869 2.89675 8.77262C1.85035 9.48655 2.00852 10.882 2.00852 12C2.00852 13.118 1.85035 14.5134 2.89675 15.2274C3.40084 15.5713 4.10257 15.5713 5.50604 15.5713C7.11085 15.5713 7.75439 15.8264 8.88232 16.9781C11.0603 19.2021 12.1494 20.3141 13.0747 19.9227C14 19.5313 14 17.9587 14 14.8135Z" />
    <path d="M17 12L22 12" />
  </svg>
);

const useStyles = makeStyles((theme) => ({
  trigger: {
    color: theme.mode === "dark" ? "#e9edef" : "#1a1a1a",
    padding: 8,
  },
  body: {
    display: "flex",
    flexDirection: "column",
    gap: 8,
    padding: 12,
    minWidth: 260,
    color: theme.mode === "dark" ? "#e9edef" : "#1a1a1a",
  },
  row: {
    display: "flex",
    alignItems: "center",
    gap: 12,
  },
}));

const NotificationsVolume = ({ volume, setVolume }) => {
  const classes = useStyles();
  const theme = useTheme();
  const anchorEl = useRef();
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = (e) => {
    e.stopPropagation();
    setIsOpen((prev) => !prev);
  };

  const handleClose = () => setIsOpen(false);

  const handleVolumeChange = (value) => {
    setVolume(value);
    try {
      localStorage.setItem("volume", value);
    } catch {}
  };

  return (
    <>
      <IconButton
        className={classes.trigger}
        onClick={handleClick}
        ref={anchorEl}
        aria-label="Volume das notificações"
      >
        <VolumeIcon />
      </IconButton>

      <ChatiaPopover
        open={isOpen}
        anchorEl={anchorEl.current}
        onClose={handleClose}
        title={null}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        paperStyle={{ minWidth: 280 }}
      >
        <div className={classes.body}>
          <Grid container spacing={2} alignItems="center" className={classes.row}>
            <Grid item style={{ display: "flex" }}>
              <VolumeDownIcon />
            </Grid>
            <Grid item xs>
              <Slider
                value={Number(volume)}
                aria-labelledby="volume-slider"
                step={0.1}
                min={0}
                max={1}
                onChange={(_, value) => handleVolumeChange(value)}
                style={{ color: theme.palette.primary.main }}
              />
            </Grid>
            <Grid item style={{ display: "flex" }}>
              <VolumeUpIcon />
            </Grid>
          </Grid>
        </div>
      </ChatiaPopover>
    </>
  );
};

export default NotificationsVolume;
